"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _upgradeStrategy = require("@/api/basic/upgradeStrategy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'upgrade',
  components: {
    SwPage: _SwPage.default
  },
  data: function data() {
    return {
      uploadAction: '#',
      listLoading: true,
      strategyList: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        guideTitle: null
      },
      dialog: {
        status: 'create',
        visible: false
      },
      formData: {},
      uploadDialog: {
        visible: false,
        row: null,
        fileList: []
      },
      rules: {
        guideTitle: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        // strategyGuideDescription: [{ required: true, message: '请输入说明', trigger: 'blur' }],
        showPictureUrl: [{
          required: true,
          message: '请上传展示图片',
          trigger: 'blur'
        }]
      },
      uploadFileList: [],
      // 显示在上传框的图片
      previewDialog: {
        visible: false,
        url: ''
      },
      resPath: process.env.VUE_APP_IMAGE_PATH
    };
  },
  created: function created() {
    this.getList();
    this.getResPathInfo();
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 272, "px");
    }
  },
  methods: {
    getResPathInfo: function getResPathInfo() {
      var _this = this;
      (0, _upgradeStrategy.getResPath)().then(function (res) {
        _this.resPath = res.data;
      });
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _upgradeStrategy.xyUpgradeStrategySelPage)(this.listQuery).then(function (res) {
        _this2.strategyList = res.records;
        _this2.total = res.total;
        setTimeout(function () {
          _this2.listLoading = false;
        }, 300);
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      this.getList();
    },
    handleCreate: function handleCreate() {
      this.dialog.status = 'create';
      this.dialog.visible = true;
      this.formData = {};
      this.uploadFileList = [];
    },
    handleUpdate: function handleUpdate(row) {
      var _this3 = this;
      (0, _upgradeStrategy.getUpgradeDetail)(row.id).then(function (res) {
        _this3.formData = res.data;
        _this3.dialog.status = 'update';
        _this3.dialog.visible = true;
        var picture = _this3.formData.showPictureUrl;
        // if (picture) {
        //   getResPath(picture).then(res => {
        //     this.resPath = res.data

        //     this.uploadFileList = [{
        //       name: '展示图',
        //       url: this.resPath
        //     }]
        //   })
        // }

        if (picture) {
          _this3.uploadFileList = [{
            name: '展示图',
            url: _this3.resPath + picture
          }];
        } else {
          _this3.uploadFileList = [];
        }
      });
    },
    handleStatusChange: function handleStatusChange(id, status) {
      var _this4 = this;
      // 调用接口更新状态
      // const newStatus = status === 1 ? 0 : 1; // 切换状态
      // 这里调用你的接口，例如：
      (0, _upgradeStrategy.updateStrategyOne)({
        id: id,
        effectiveStatus: status
      }).then(function () {
        _this4.$message.success('状态更新成功');
        _this4.getList();
      }).catch(function () {
        _this4.$message.error('状态更新失败');
      });
    },
    handleDelete: function handleDelete(row) {
      var _this5 = this;
      this.$confirm('确认删除该攻略？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _upgradeStrategy.deleteStrategyById)(row.id).then(function () {
          _this5.$message.success('删除成功');
          _this5.getList();
        });
      });
    },
    handleDrawerClose: function handleDrawerClose() {
      var _this6 = this;
      this.dialog.visible = false;
      this.formData = {};
      this.uploadFileList = [];
      this.$nextTick(function () {
        _this6.$refs.form.clearValidate();
      });
    },
    submitForm: function submitForm() {
      var _this7 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        var api = _this7.dialog.status === 'create' ? _upgradeStrategy.insertStrategyNew : _upgradeStrategy.updateStrategyOne;
        api(_this7.formData).then(function () {
          _this7.$message.success(_this7.dialog.status === 'create' ? '创建成功' : '更新成功');
          _this7.handleDrawerClose();
          _this7.getList();
        });
      });
    },
    handleUploadDialog: function handleUploadDialog(row) {
      this.uploadDialog.row = row;
      this.uploadDialog.visible = true;
      this.uploadDialog.fileList = [];
    },
    handleCustomUpload: function handleCustomUpload(_ref) {
      var _this8 = this;
      var file = _ref.file;
      var formData = new FormData();
      formData.append('file', file);
      formData.append('id', this.uploadDialog.row.id);
      (0, _upgradeStrategy.uploadStrategyPhoto)(formData).then(function () {
        _this8.$message.success('上传成功');
        _this8.uploadDialog.visible = false;
        // this.uploadDialog.fileList = [uploadOption.file];
        _this8.getList();
      }).catch(function () {
        _this8.$message.error('上传失败');
        _this8.uploadDialog.visible = false;
      });
    },
    handleFileChange: function handleFileChange(file, fileList) {
      this.uploadDialog.fileList = [file];
    },
    removeFile: function removeFile() {
      this.uploadDialog.fileList = [];
    },
    resetUpload: function resetUpload() {
      this.uploadDialog.fileList = [];
      this.uploadDialog.row = null;
    },
    handlePictureUpload: function handlePictureUpload(_ref2) {
      var _this9 = this;
      var file = _ref2.file;
      var formData = new FormData();
      formData.append('file', file);
      (0, _upgradeStrategy.uploadPhotoAddOrUpd)(formData).then(function (res) {
        var url = res.data; // 按实际调整

        // 更新展示地址
        _this9.formData.showPictureUrl = url;

        // 替换上传组件的 fileList（最多一张）
        _this9.uploadFileList = [{
          name: '展示图',
          url: _this9.resPath + url
        }];
        _this9.$message.success('上传成功');
      }).catch(function () {
        _this9.$message.error('上传失败');
      });
    },
    handleRemoveFile: function handleRemoveFile() {
      this.uploadFileList = [];
      this.formData.showPictureUrl = '';
    },
    handlePreview: function handlePreview(file) {
      this.previewDialog.url = file.url;
      this.previewDialog.visible = true;
    }
  }
};